import * as React from "react";
import { BarChart } from '@mui/x-charts';
import { forEach } from "lodash";

const ScatterBarChart = ({ chart_data, isFullWidth }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getChartData = () => {
        const isTree = chartType === 'treemap';
        const xAxisData = data?.map(d => isTree ? d?.category : `Level ${d?.difficulty}`);
        const successRateSeries = data?.map(d => isTree ? d?.revenue : d?.successRate);
        const questionCountSeries = data?.map(d => isTree ? d?.percentage : d?.questionCount);

        return { isTree, xAxisData, successRateSeries, questionCountSeries};
    };

    const { isTree, xAxisData, successRateSeries, questionCountSeries } = getChartData();

    const chartSetting = {
        yAxis: [
            {
                label: '',
                width: 50,
            },
        ],
        height: 300,
    };

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data?.title || chart_data?.chart_name}</h3>
            <p>{chart_data?.description}</p>
            <BarChart
                xAxis={[{ data: xAxisData, scaleType:'band'  }]}
                series={[
                    { label: isTree ? 'Revenue' : 'Success Rate %', data: successRateSeries },
                    { label: isTree ? 'Percentage' : 'Questions Count', data: questionCountSeries },
                  ]}
                {...chartSetting}
            />
        </div>
    );

}

const styles = {
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
    cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
};

export default ScatterBarChart;